var render, staticRenderFns
import script from "./DraggableItem3.vue?vue&type=script&lang=js"
export * from "./DraggableItem3.vue?vue&type=script&lang=js"
import style0 from "./DraggableItem3.vue?vue&type=style&index=0&id=ff126d54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff126d54",
  null
  
)

export default component.exports